<template>
    <div class="splitted-view" ref="root" v-show="visible"  
          @pointerup="moving=false"
          @mouseleave="moving=false" 
          @touchend="moving=false"
          @touchmove="resizing"
          @mousemove="resizing"> 
         
        <div class="area">
            <div class="resize " :style="{width:`100%`}" > 
              <div class="fixed">
                <slot name="left"></slot> 
              </div>
            </div>
            <div class="resize right" :style="{width:`calc( ${perc}% - 5px )`}">  
              <div class="fixed">
                <slot name="right"></slot> 
              </div>
            </div>
        </div>

        <div 
          class="slider-dot" 
          @pointerdown="moving=true" 
          @touchstart="moving=true" 
          style="-moz-user-select: none; -webkit-user-select: none; -ms-user-select:none; user-select:none;-o-user-select:none;" 
          @selectstart="false" 
          @mousedown="false"
          :style="{'left':`${perc}%`}">
            <i class="material-icons">keyboard_arrow_left</i> 
            <i class="material-icons">keyboard_arrow_right</i> 
        </div>
        
    </div>
</template>

<script> 


export default {
    name: 'splitted-view',     
    props: {
        'dontanimate': {default: true, type:Boolean},
        'titolo': {
            type: String,
            default: "Inserire Titolo"
        }
    },
    data() {
        return {
            active: ["r"],
            perc:50, 
            visible: true,
            cl: [],
            moving: false,
        }
    },
    mounted() {  
    },
    methods: {
      hide() {
        this.visible = false;
      },
      show() {
        this.visible = true;
      },
      resizing(event) {    
        let bodyRect = this.$refs.root.getBoundingClientRect();

        if(this.moving) {
          let x = event.clientX - bodyRect.left;
          if(event.touches) {
            x = event.touches[0].clientX - bodyRect.left;
          }
          this.perc = x/this.$refs.root.clientWidth*100;
        }
      },

    }
}
</script>

<style scoped>
.splitted-view {
    /* position: absolute;
    top: 0;
    left: 0; */
    overflow: hidden;
    position: relative; 
}
.area {
    position: relative;
    width: var(--width);
    height: 100%;
}
.resize { 
    left:0;
    height: 100%;
    position: absolute;
    overflow: hidden;
}
.resize:nth-child(1)  { 
    background-color: yellow;
}
.resize:nth-child(2)  {  
    background-color: red;
}
.fixed {
    height: 100%;
    width: 100vw;
    position: relative;
}
 
.slider-dot {
  --size: 50px;
  position: absolute;
  top: 0;
  left: 0;
  top: calc( 50% - var(--size)/2);
  margin-left: calc( -1*var(--size) / 2 );
  width: var(--size);
  height: var(--size);
  border-radius: var(--size);
  background-color: var(--primary-color);
  box-shadow: 0px 0px 10px rgba(43, 43, 43, 0.5);
  color: rgba(43, 43, 43, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

}
.right {
  border-right: 10px solid var(--background-color);
}
.material-icons {
  pointer-events: none;
}
</style>